/**
 * Small shared primitives reused across multiple Landing sub-components.
 * Extracted from Landing.jsx in the components-split refactor.
 */
export function Stat({ label, value }) {
  return (
    <div>
      <div className="font-display text-sm sm:text-base md:text-2xl font-bold text-slate-900 leading-tight">{value}</div>
      <div className="text-[10px] sm:text-xs text-slate-500 uppercase tracking-wider font-semibold mt-1">{label}</div>
    </div>
  );
}

export function Badge({ icon: Icon, title, sub }) {
  return (
    <div className="flex items-start gap-3 p-3 rounded-xl bg-slate-50 border border-slate-200">
      <div className="w-9 h-9 rounded-lg bg-green-50 text-green-800 flex items-center justify-center flex-none">
        <Icon className="w-5 h-5"/>
      </div>
      <div className="min-w-0">
        <div className="text-sm font-bold text-slate-900 leading-snug">{title}</div>
        <div className="text-xs text-slate-700 leading-snug mt-1">{sub}</div>
      </div>
    </div>
  );
}
